<template>
  <v-container>

  <v-app-bar app color="primary" dark>
      <v-btn text>
        <h4 class="ml-2" v-if="tipoMensagem==1">Entre em contato</h4>
        <h4 class="ml-2" v-if="tipoMensagem==2">Apoio, Suporte</h4>
      </v-btn>
  </v-app-bar>

  <v-card class="mx-auto my-2" max-width="600">
  
   <v-flex class="mt-6 px-2">
    <div>
      <v-row justify="center">
        <span class="ml-2 blue--text caption" v-if="tipoMensagem==1">Nosso objetivo é fornecer o melhor atendimento e responder a todas as perguntas em tempo hábil.</span>
        <span class="ml-2 blue--text caption" v-if="tipoMensagem==2">Converse com o nosso suporte</span>
      </v-row>
    </div>
    </v-flex>

  <v-layout column align-center>   
      <v-flex class="mt-5">
            <v-img v-show="Number(site) == 1" max-height="119" max-width="300">
              <img src="logo_TechGenesis.png" v-show="Number(site) == 1"> 
            </v-img>
            <v-img v-show="Number(site) == 2" max-height="119" max-width="300">
              <img src="logo_TGMembers.png"> 
            </v-img>
      </v-flex>
  </v-layout>

  <v-layout column wrap>  
    <v-flex class="mt-1 px-2">
          <v-form v-show="avisoSucesso == '' ">
            <v-text-field label="Nome" v-model="nome" prepend-icon="mdi-account-circle" @focus="avisoErro = ''"></v-text-field>
            <v-text-field label="E-mail" v-model="email" prepend-icon="email" @focus="avisoErro = ''"></v-text-field>
            <v-text-field label="Telefone" v-model="telefone" prepend-icon="phone" @focus="avisoErro = ''"></v-text-field>
            <v-textarea label="Mensagem" v-model="mensagem" prepend-icon="message" @focus="avisoErro = ''"></v-textarea>
     
            <div v-show="!avisoErro == '' ">
               <v-row justify="center">
                <v-alert prominent text type="error">
                   {{ avisoErro }}
                </v-alert>
               </v-row>
            </div>

           
     
            <v-row class="mt-3 mb-3" justify="center">
                <vue-recaptcha sitekey="6LeAGxkaAAAAAIxa0zwaClmx8LhSzcwssDA9NLcs" @verify="onVerify" :loadRecaptchaScript="true"></vue-recaptcha>
            </v-row>

            <v-card-actions class="mt-3 mb-3">
              <v-row justify="center">
                <v-btn small class="primary" @click="validaCampos" :loading="loading">Enviar</v-btn>
              </v-row>
            </v-card-actions>

          </v-form>

           <div v-show="!avisoSucesso == '' ">
               <v-row justify="center">
                <v-alert prominent text type="success">
                   {{ avisoSucesso }}
                </v-alert>
               </v-row>
            </div>

      </v-flex>        
    </v-layout>
  </v-card>
  </v-container>
</template>

<script>
  import VueRecaptcha from 'vue-recaptcha';
  import axios from "axios";
  import caminhoAPI from "../config/configAPI";

  export default {
    components:  { VueRecaptcha },
    data() {
     return {
       tipoMensagem: 0, //1-contato   //2-suporte (default 0)
       site: 0,         //1-www.techgenesis.com.br //2-www.tgmembers.com.br (default 0)
       avisoErro: '',
       avisoSucesso: '',
       loading: false,
       nome: '',
       email: '',
       telefone: '',
       mensagem: '',
       captcha: false,
       tipoCaminho: 3, //(default 3)
       token: '',
     }
    },
    methods: {
      limpaCampos() {
        this.nome = '';
        this.email = '';
        this.telefone = '';
        this.mensagem = '';
      },
      validaCampos() {
        if (this.nome < 1 || this.nome.trim == '')
        {
          this.avisoErro = "Precisa informar o nome";
          return;
        }

        if (this.email < 1 || this.email.trim == '')
        {
          this.avisoErro = "Precisa informar o email";
          return;
        }
        
        if (this.telefone < 1 || this.telefone.trim == '')
        {
          this.avisoErro = "Precisa informar o telefone";
          return;
        }

        if (this.mensagem < 1 || this.mensagem.trim == '')
        {
          this.avisoErro = "Precisa informar a mensagem";
          return;
        }

        if (this.captcha == false)
        {
          this.avisoErro = "Por segurança, é necessário selecionar o capcha abaixo!"
          return;
        }

        this.insereEmail();

      },
      onVerify: function (response) {
        this.avisoErro = "";
        if (response) this.captcha = true;
      },
      async retornaToken() {
        const header = { headers: { "Content-Type": "application/json" } };
        const dados = {};
        await axios.get(caminhoAPI(this.tipoCaminho) + "retornaToken", dados ,header).then(res => {
          this.token = (res.data.token);
        })
      },
      async insereEmail() {
       
       try {

         this.loading = true;
         const token = this.token;
         const autorizaAxios = axios.create({
                baseURL: caminhoAPI(this.tipoCaminho),
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

          const dados = {
            nome: this.nome,
            email: this.email,
            telefone: this.telefone,
            mensagem: this.mensagem,
            tipo: this.tipoMensagem,
            site: this.site,
          };
       
          await autorizaAxios.post("insereEmail", dados).then(() =>
          {
            this.limpaCampos();
            this.avisoSucesso = "E-mail enviado com sucesso!";
          });

      } catch (error) {
        this.avisoErro = "Não foi possível enviar o email, \n tente mais tarde!";
        console.log(error)
      }
      finally {
          this.loading = false;
      }

      },
    },
    mounted() {
    let uri = window.location.href.split('?');
    if (uri.length == 2)
    {
      let vars = uri[1].split('&');
      let getVars = {};
      let tmp = '';
      vars.forEach(function(v){
        tmp = v.split('=');
        if(tmp.length == 2)
        getVars[tmp[0]] = tmp[1];
      });
      this.tipoMensagem = getVars['tp'];
      this.site = getVars['st'];
      this.retornaToken()
    }
  },
 
  }
</script>

<style scoped>

img { 
    width:100%; 
    height:100%; 
} 

.v-select__slot {
  font-family: monospace !important;
  background-color: red;
}

</style>